<template lang="pug">
  div
    el-dialog(
      :title="isEdit ? 'Editar modelo - Notificação' : 'Adicionar modelo - Notificação'"
      :visible.sync='showModal'
      width='60%'
      v-loading='loadingModel'
    )
      el-form(
        :rules='rules'
        ref='formModelo'
        :model='formModelo'
        label-position='top'
      )
        el-form-item(label='Descrição da notificação' prop='assunto')
          el-input(v-model='formModelo.assunto' maxlength='200')

        el-form-item(label='Notificação' prop='conteudo')
          vue-editor(v-model='formModelo.conteudo' :editor-toolbar='customToolbar')

      el-row(type='flex' justify='space-between')
        el-button(@click='fecharModal')
          i(style='padding-right: 5px;').fa.fa-times
          span Cancelar
        el-button(
          type='primary'
          @click='cadastrarModelo'
        )
          i(style='padding-right: 5px;').fa.fa-save
          span Salvar
</template>
<script>
import { VueEditor } from 'vue2-editor';
import { AppNotificacao } from 'sicarf-components';
import { cadastrar, editar } from '@/services/modeloService';

export default {
  components: {
    VueEditor,
  },

  mixins: [
    AppNotificacao
  ],

  props: {
    modalOpen: {
      type: Boolean,
      default: false,
    },
    modelo: {
      type: Object,
      required: false,
    },
  },

  computed: {
    showModal: {
      get() {
        return this.modalOpen;
      },
      set() {
        this.$emit('close-modal');
      }
    }
  },

  data() {
    return {
      loadingModel: false,
      isEdit: false,
      formModelo: {
        assunto: '',
        conteudo: '',
      },
      rules: {
        assunto: [
          { required: true, message: 'Defina um assunto', trigger: 'blur' },
          { min: 5, message: 'Assunto precisa ter pelo menos 5 caracteres', trigger: 'blur' }
        ],
        conteudo: [
          { required: true, message: 'A mensagem é obrigatória', trigger: 'blur' }
        ],
      },
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
        [{ clean: true }],
      ],
    }
  },

  mounted() {
    if (this.modelo) {
      this.formModelo.assunto = this.modelo.assunto;
      this.formModelo.conteudo = this.modelo.conteudo;
      this.isEdit = true;
    }
  },

  methods: {
    fecharModal() {
      this.$emit('close-modal');
    },

    cadastrarModelo() {
      this.$refs.formModelo.validate(async (valid) => {
        if (valid) {
          this.loadingModel = true;
          try {
            if (this.isEdit) {
              const modelo = this.modelo;
              modelo.assunto = this.formModelo.assunto;
              modelo.conteudo = this.formModelo.conteudo;

              await editar(modelo);
              this.showNotificacao(
                this.$messages.TIPO_SUCCESS,
                this.$messages.TITULO_SUCCESS,
                this.$messages.MODELO_EDITADO
              )
            } else {
              await cadastrar(this.formModelo);
              this.showNotificacao(
                this.$messages.TIPO_SUCCESS,
                this.$messages.TITULO_SUCCESS,
                this.$messages.MODELO_CADASTRADO
              )
            }
            this.loadingModel = false;
            this.$emit('modelo-cadastrado');
          } catch (e) {
            this.loadingModel = false;
          }
        }
      })
    },
  }
}
</script>
